import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { authenticationSuccess, authenticationTimeout, authenticationLogout } from '../store/actions/authentication';

import JsonValidator from '../lib/JsonValidator';

const withAuthentication = (WrappedComponent) => {

    class HOC extends Component {

        state = {
            redirect: false,
            isValid: false,
            roles: [],
            permissions: []
        };
        componentWillMount() {
            // Check to see if they already have authData in the store
            const authObject = localStorage.getItem('authData');
            let valid = (authObject && JsonValidator(authObject));

            // If we have auth data, then let's start parsing it
            if (valid) {
                // Parse it and make sure we have the fields we need
                const authData = JSON.parse(authObject);

                // If they have fm included, then we let them on.
                if (!_.isEmpty(authData['permissions'])) {
                    const successProps = {
                        access_token: authData['accessToken'],
                        fullName: authData['fullName'],
                        userName: authData['username'],
                        roles: authData['roles'],
                        permissions: authData['permissions']
                    };

                    if (window.location.pathname !== '/') {
                        successProps['prevRoute'] = window.location.pathname;
                    }

                    // Send success and timeout updates
                    this.props.onAuthenticationSuccess(successProps);

                    this.setState({ redirect: false, isValid: true, roles: authData['roles'], permissions: authData['permissions'] });
                } else {
                    valid = false;
                }
            }

            if (!valid) {
                localStorage.clear();
                this.props.onAuthenticationLogout();
            }
        }

        render() {
            let wrappedComponent = <WrappedComponent {...this.props} />;

            return (
                <React.Fragment>
                    {wrappedComponent}
                </React.Fragment>
            );
        }
    };

    const mapDispatchToProps = (dispatch) => ({
        onAuthenticationSuccess: (options) => dispatch(authenticationSuccess(options)),
        onAuthenticationTimeout: (expiresIn) => dispatch(authenticationTimeout(expiresIn)),
        onAuthenticationLogout: () => dispatch(authenticationLogout())
    });

    return connect(null, mapDispatchToProps)(HOC);
};

export default withAuthentication;
